import { ONETRUST_PREFIX, OneTrustCategories } from 'onetrust/constants';
import { Diagnostics } from 'util/diagnostics';
import { pushDataLayer, GTM_DATA_LAYER_NAME } from 'gtm/gtm';
import { IOneTrustCookieGroups } from 'onetrust/types';
import { IS_SSR } from 'ots-constants';

export const DEBUG_TAG = '[GTMHeader]';

export const GTMHeader = ({ preAllowedGroups }: { preAllowedGroups: IOneTrustCookieGroups }) => {
  const preAllowedTargeting = preAllowedGroups[OneTrustCategories.TargetingCookies];
  Diagnostics.debug(DEBUG_TAG, IS_SSR, preAllowedTargeting ? 'Targeting pre-allowed' : 'Targeting not pre-allowed');

  const l: string = GTM_DATA_LAYER_NAME;
  pushDataLayer(GTM_DATA_LAYER_NAME, {});
  const dl = l !== 'dataLayer' ? `&l=${l}` : '';
  const src = `https://www.googletagmanager.com/gtm.js?id=${process.env.NEXT_PUBLIC_GOOGLE_TAG}${dl}`;

  return (
    <>
      <script
        src={src}
        type={preAllowedTargeting ? 'text/javascript' : 'text/plain'}
        async
        className={`${ONETRUST_PREFIX}${OneTrustCategories.TargetingCookies}`}
      />
    </>
  );
};

export const GTMIframe = () => (
  <noscript>
    <iframe
      title="Google Tag Manager"
      src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GOOGLE_TAG}`}
      height="0"
      width="0"
      style={{ display: 'none', visibility: 'hidden' }}
    />
  </noscript>
);
